// ==============================查运价API==============================
import { jsonPost } from '@/utils/request'

/**
 * @description  运价查询
 *
 * @export
 * @param {*} params
 */
export function fclListAPI(params) {
    return jsonPost({
        url: `/freightRate/wzFreightRatelist`,
        params
    })

}
/**
 * @description  筛选列表查询
 *
 * @export
 * @param {*} params
 */
export function filterListAPI(params) {
    return jsonPost({
        url: `/freightRate/screenFreightRateList`,
        params
    })

}
/**
 * @description  附加费查询
 * 
 *
 * @export
 * @param {*} params
 */
export function additionalChargeAPI(params) {
    return jsonPost({
        url: `/freightRate/wzaSurcharge`,
        params
    })

}

/**
 * @description  运价详情
 *
 * @export
 * @param {*} params
 */
export function fclDetailAPI(params) {
    return jsonPost({
        url: `/freightRate/fclfreightdetail`,
        params
    })

}

/**
 * @description  根据运价数据查询报价单详情
 *
 * @export
 * @param {*} params
 */
export function quotationDetailFromFclAPI(params) {
    return jsonPost({
        url: `/freightRate/quotationdetailbyfclfreight`,
        params
    })

}

/**
 * @description  报价单用户信息获取
 *
 * @export
 * @param {*} params
 */
export function userInfoAPI(params) {
    return jsonPost({
        // url: `/wzpcquotation/wzmyMessageNew `,
        url: `/wzpcquotation/wzmyMessageB`,
        params
    })

}

/**
 * @description  保存报价单
 *
 * @export
 * @param {*} params
 */
export function saveQuotationAPI(params) {
    return jsonPost({
        url: `/freightRate/savequotation`,
        params
    })

}

/**
 * @description  根据报价单id查询详情
 *
 * @export
 * @param {*} params
 */
export function quotationDetailAPI(params) {
    return jsonPost({
        url: `/wzpcquotation/wzQuotationDetailNew `,
        params
    })

}

